import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import EventListWeek from './EventListWeek.jsx';
import { filterByMonth } from '../services/filters/filterByWeekAndMonth';
import filterByBoundingBox from '../services/filters/filterByBoundingBox';

import './css/EventListContent.css';

class EventListMonth extends Component {
  getEventsInsideBbox() {
    if (this.props.checkboxState === true && this.props.selectedBbox.bbox.length !== 0) {
      return this.props.mapEvents.filter(event => filterByBoundingBox(event, this.props.selectedBbox.bbox));
    }

    return this.props.mapEvents;
  }

  getMonthEvents(currentMonth) {
    const monthRangeDate = moment(this.props.yearViewDate.month(currentMonth));
    const eventList = this.getEventsInsideBbox().filter(event => filterByMonth(event, monthRangeDate));

    return eventList;
  }

  setMonthDiv(month) {
    if (this.getMonthEvents(month).length > 0) {
      return (
        <div className="listContentMonth" key={month}>
          <h3>{month.charAt(0).toUpperCase() + month.slice(1)} {this.props.yearViewDate.year()}</h3>
        </div>
      );
    }

    return (
      <div />
    );
  }

  render() {
    this.getEventsInsideBbox();
    return (
      <div>
        {moment.months().map(month => (
          <div key={month}>
            {this.setMonthDiv(month)}
            <EventListWeek
              yearViewDate={this.props.yearViewDate}
              currentMonth={month}
              monthEvents={this.getMonthEvents(month)}
              changeMapView={this.props.changeMapView}
            />
          </div>
        ))}
      </div>
    );
  }
}

EventListMonth.propTypes = {
  yearViewDate: PropTypes.object.isRequired,
  mapEvents: PropTypes.array.isRequired,
  selectedBbox: PropTypes.object.isRequired,
  checkboxState: PropTypes.bool.isRequired,
  changeMapView: PropTypes.func.isRequired
};

export default EventListMonth;



// WEBPACK FOOTER //
// ./src/components/EventListMonth.jsx